<template>
    <v-container fluid v-if="!isLoading" class="flex-column">
        <h1 class="page-title page-title__primary mb-4">Параметры прогноза</h1>
        <v-form>
            <v-text-field v-model="predictParams.nsteps" label="Количество шагов" type="number" outlined></v-text-field>
            <v-text-field v-model="predictParams.step_days" label="Длительность шага в днях" type="number" outlined></v-text-field>
            <v-select v-model="predictParams.wells_predict_param"
                      label="Параметр для отбора скважин"
                      :items="wellPredictParams" outlined v-if="optimizeTask.type === 'wells'"></v-select>
            <v-text-field v-model="predictParams.wells_count" label="Количество новых скважин" type="number" outlined v-if="optimizeTask.type === 'wells'"></v-text-field>
        </v-form>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            isLoading: true,
            taskLoaded: false,
            predictParams: {
                nsteps: 50,
                step_days: 1,
                wells_predict_param: null,
                wells_count: null,
            },
            wellPredictParams: [
                {text: 'Общий дебит нефти', value: 'total_oil'}
            ]
        }
    },
    created() {
        this.emitInput();
    },
    mounted() {
        if (!this.task) {
            this.loadTask();
        }
        else if (this.task && this.task.problemId !== this.problemId) {
            this.loadTask();
        }
        else {
            this.isLoading = false;
        }

        this.emitInput();
    },
    watch: {
        task: {
            deep: true,
            handler() {
                if (this.task && this.task.params && this.taskLoaded === false) {
                    this.predictParams = this.task.params;
                    this.taskLoaded = true;
                }
            }
        },
        optimizeTask: {
            deep: true,
            handler() {
                this.emitInput();
            }
        },
        predictParams: {
            deep: true,
            handler() {
                this.emitInput();
            }
        },

    },
    methods: {
        loadTask() {
            this.isLoading = true;
            this.$store.dispatch('task/loadItem', this.problemId);
            this.$store.dispatch('task/loadPredictItem', this.problemId);
            this.isLoading = false;
        },
        emitInput() {
            let task = Object.assign({}, this.task);
            task.problemId = this.problemId;
            task.type = 'predict';
            if (this.optimizeTask.type === 'wells') {
                task.sub_type = 'wells';
            }
            task.optimize_id = this.optimizeTask.id;
            task.params = Object.assign(task.params || {}, this.predictParams);
            task.params.nsteps = parseInt(task.params.nsteps);
            task.params.step_days = parseFloat(task.params.step_days);

            this.$emit('input', task);
        }
    },
    computed: {
        problemId() {
            return this.$route.params && this.$route.params.id
                ? this.$route.params.id || null
                : null;
        },
        optimizeTask() {
            return  this.$store.state.task.wells || this.$store.state.task.optimize || {};
        },
        task() {
            return this.$store.state.task.predict || {};
        }
    }
}
</script>

<style scoped>

</style>